import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-logo-episource',
})
export class SignetLogoEpisource {
  /**
   * Destination of the Logo
   */
  @Prop() href =  "http://episource.com";
  
  /**
   * SRC of the logo (Optional)
   */
  @Prop() src =  'https://design.episource.com/img/logo/Product=Global.svg';

  /**
   * Alternative Text
   */
    @Prop() alt =  'Episource Logo';

  private getLogoLink(): string {
    return ( this.href );
  }

  private getImageLink(): string {
    return ( this.src );
  }


  private getAltText(): string {
    return ( this.alt );
  }

  render() {
    return (
      <a class='signet-logo-episource signet-product-icon' href={this.getLogoLink()}><img src={this.getImageLink()} alt={this.getAltText()} /></a>
    );
  }
}
